import * as angular from "angular";
import {IController} from "angular";

export class resourceInfoCtrl implements IController {

  resource: any;

  /* @ngInject */
  constructor() {}


}
angular
  .module('bringoz.admin.resources')
  .component('resourceInfo', {
    bindings: {
      resource: '<',
    },
    template: require('./resource-info.html').default,
    controller: resourceInfoCtrl
  });
